import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34a7a133"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "現在もしくは直近の"),
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "業種・職種を教えてください")
], -1))
const _hoisted_4 = { class: "entry_base_businesstype" }
const _hoisted_5 = { class: "entry_base_businesstype_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "業種"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/102",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）業種一覧 ")
], -1))
const _hoisted_7 = { class: "input_form" }
const _hoisted_8 = { class: "entry_base_businesstype_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "職種"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/101",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）職種一覧 ")
], -1))
const _hoisted_10 = { class: "input_form" }
const _hoisted_11 = { class: "entry_base_button" }
const _hoisted_12 = { class: "entry_base_button_prev" }
const _hoisted_13 = { class: "entry_base_button_next" }

import { onBeforeMount, ref, Ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import alertOnReload from '@/utils/alertOnReload';
import BaseSelectButton from '@/components/BaseSelectButton.vue';
import BaseButton from '@/components/BaseButton.vue';
import Indicator from '@/components/Indicator.vue';
import EditRadioModal from '@/components/EditRadioModal.vue';
import { RadioListType } from '@/types';
import { getMasterDataListIndsctg, getMasterDataOcupClass } from '@/api/entryMasterDataEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinesstypeView',
  setup(__props) {

const industryList: Ref<RadioListType[]> = ref([]);
const selectedIndustryValue = ref(store.getters['userRegistration/indsctgId']);
const selectedIndustryText = ref('');
const clearIndustry = () => {
  selectedIndustryValue.value = '';
};

const occupationList: Ref<RadioListType[]> = ref([]);
const selectedOccupationValue = ref(store.getters['userRegistration/ocupId']);
const selectedOccupationText = ref('');
const clearOccupation = () => {
  selectedOccupationValue.value = '';
};

watchEffect(() => {
  // 選択した業種の値に該当するテキストを設定する
  const industryTextList = industryList.value.map((i) => i.children).flat();
  selectedIndustryText.value = industryTextList.filter((i) => i?.value === selectedIndustryValue.value)[0]?.label || '';

  // 選択した職種の値に該当するテキストを設定する
  const occupationTextList = occupationList.value
    .map((i) => i.children?.map((j) => j.children))
    .flat()
    .flat();
  selectedOccupationText.value = occupationTextList.filter((i) => i?.value === selectedOccupationValue.value)[0]?.label || '';
});

const shownOccupationModal = ref(false);
const openOccupationModal = () => (shownOccupationModal.value = true);
const closeOccupationModal = () => (shownOccupationModal.value = false);
const shownIndustryModal = ref(false);
const openIndustryModal = () => (shownIndustryModal.value = true);
const closeIndustryModal = () => (shownIndustryModal.value = false);

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'b01' });
};
const transitionNextPage = () => {
  store.commit('userRegistration/setIndsctgId', selectedIndustryValue.value);
  store.commit('userRegistration/setOcupId', selectedOccupationValue.value);
  router.push({ name: 'b00' });
};

onBeforeMount(async () => {
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }
  getMasterDataListIndsctg()
    .then((res) => {
      industryList.value = res.map((i) => {
        return {
          type: 'default',
          label: i.indsctgLargeName,
          value: i.indsctgLargeId,
          children: i.mstIndsctgSmallDataList.map((j) => {
            return {
              type: 'radio',
              label: j.indsctgSmallName,
              value: j.indsctgSmallId,
            };
          }),
        };
      });
    })
    .catch((e) => {
      console.error(e);
    });
  getMasterDataOcupClass()
    .then((res) => {
      occupationList.value = res.map((i) => {
        return {
          type: 'default',
          label: i.ocup1ClassName,
          value: i.ocup1ClassId,
          children: i.mstOcup2ClassDataList.map((j) => {
            return {
              type: 'default',
              label: j.ocup2ClassName,
              value: j.ocup2ClassId,
              children: j.mstOcup3ClassDataList.map((k) => {
                return {
                  type: 'radio',
                  label: k.ocup3ClassName,
                  value: k.ocup3ClassId,
                };
              }),
            };
          }),
        };
      });
    })
    .catch((e) => {
      console.error(e);
    });
});
alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 3,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseSelectButton, {
              placeholder: "業種を選択",
              modelValue: selectedIndustryText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedIndustryText).value = $event)),
              onClick: openIndustryModal,
              onClear: clearIndustry
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseSelectButton, {
              placeholder: "職種を選択",
              modelValue: selectedOccupationText.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOccupationText).value = $event)),
              onClick: openOccupationModal,
              onClear: clearOccupation
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseButton, {
            onClick: transitionNextPage,
            disabled: !selectedIndustryValue.value || !selectedOccupationValue.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "職種選択",
      modelValue: selectedOccupationValue.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOccupationValue).value = $event)),
      list: occupationList.value,
      onClose: closeOccupationModal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownOccupationModal.value]
    ]),
    _withDirectives(_createVNode(EditRadioModal, {
      title: "業種を選択",
      modelValue: selectedIndustryValue.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedIndustryValue).value = $event)),
      list: industryList.value,
      onClose: closeIndustryModal
    }, null, 8, ["modelValue", "list"]), [
      [_vShow, shownIndustryModal.value]
    ])
  ]))
}
}

})